// If using a module system (e.g. via vue-cli), import Vue and VueRouter
// and then call `Vue.use(VueRouter)`.
import Vue from 'vue'

// Vue Router
// The official router for Vue.js.
// https://github.com/vuejs/vue-router
import VueRouter from 'vue-router'

// Store
import DownloadApps from '@/views/DownloadApps.vue'
import NotFound from '@/views/404.vue'

// Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.

const routes = [
  { path: '/', component: DownloadApps, name: 'production' },
  // Qualquer rota desconhecida, redireciona para 404
  { path: '*', component: NotFound }
]

Vue.use(VueRouter)

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes // short for `routes: routes`
})

export default router
